export const data = function () {
  return {
    dialogIndicadores: false,
    showComprovante: false,
    showComprovanteLaudo: false,
    showComprovanteAgendamento: false,
    page: {
      title: 'Relatório de Cotas Cliente',
    },
    breadcrumbs: [
      {
        text: 'Relatórios',
        disabled: false,
      },
      {
        text: 'Relatório de Cotas Cliente',
        disabled: false,
      },
    ],
  }
}
